import {
  Button,
  DismissIcon,
  Flex,
  JaneLogo,
  Modal,
  Typography,
} from '@iheartjane/reefer';
import type { CSSProperties, ReactNode } from 'react';

import styles from './wizardModal.module.css';

export interface WizardModalProps {
  children: ReactNode;
  headerActions?: ReactNode;
  headerColor: string;
  isOpen: boolean;
  logoUrl?: string;
  onClose: () => void;
}

export const WizardModal = ({
  children,
  headerActions,
  headerColor,
  isOpen,
  logoUrl,
  onClose,
}: WizardModalProps) => {
  const poweredByJane = (
    <Flex alignItems="center" justifyContent="center" gap={4} width="100%">
      <Typography color="grays-mid" variant="mini">
        Powered by
      </Typography>
      <JaneLogo
        className={styles['footerLogo']}
        variant="secondary"
        size="xs"
        removeSafeSpace
      />
    </Flex>
  );

  return (
    <Modal
      open={isOpen}
      onRequestClose={onClose}
      variant="standard"
      className={styles['modal']}
    >
      <Flex
        alignItems="center"
        background="grays-white"
        height={72}
        mx={24}
        my={8}
        position="relative"
        style={{ '--wizard-header-color': headerColor } satisfies CSSProperties}
        data-testid="wizard-modal-header"
      >
        <Button.Icon
          className={styles['icon']}
          icon={<DismissIcon />}
          label="Close wizard"
          onClick={onClose}
          variant="minimal"
        />
        {logoUrl && (
          <Flex className={styles['logoPill']}>
            <img src={logoUrl} alt="" className={styles['logoImage']} />
          </Flex>
        )}
        {headerActions && (
          <Flex
            alignItems="center"
            className={styles['headerActions']}
            gap={16}
          >
            {headerActions}
          </Flex>
        )}
      </Flex>
      <Modal.Content padding={false}>
        <Flex flexDirection="column" height="100%">
          {children}
          <div className={styles['inlineFooter']}>{poweredByJane}</div>
        </Flex>
      </Modal.Content>
      <Modal.Footer className={styles['footer']}>{poweredByJane}</Modal.Footer>
    </Modal>
  );
};
